var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9418 19.7318C23.1778 18.2408 22.1663 16.0615 22.1663 13.7527V10.5C22.1663 6.3945 19.1167 2.996 15.1663 2.42667V1.16667C15.1663 0.5215 14.6437 0 13.9997 0C13.3557 0 12.833 0.5215 12.833 1.16667V2.42667C8.88151 2.996 5.83301 6.3945 5.83301 10.5V13.7527C5.83301 16.0615 4.82151 18.2408 3.04701 19.7412C2.59317 20.1297 2.33301 20.6943 2.33301 21.2917C2.33301 22.4175 3.24884 23.3333 4.37467 23.3333H23.6247C24.7505 23.3333 25.6663 22.4175 25.6663 21.2917C25.6663 20.6943 25.4062 20.1297 24.9418 19.7318Z",
    fill: "#192252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9992 28C16.1121 28 17.8796 26.4938 18.2856 24.5H9.71289C10.1189 26.4938 11.8864 28 13.9992 28Z",
    fill: "#192252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a9f9b90d3702bcc5bf03a526e928ad0d.svg";
export { ForwardRef as ReactComponent };